<template>
    <van-sticky :offset-top="0">
      <demo-block :title="('')">
        <van-nav-bar :title="('充电桩信息')" :left-text="('返回')" left-arrow @click-left="this.$router.push('energyindex')">
          <template #right>
            <van-icon v-if="paytype===0 || paytype ===1" name="wechat-pay" size="18" />
            <van-icon v-if="paytype===2" name="alipay" size="18" />
          </template>
        </van-nav-bar>
      </demo-block>
    </van-sticky>
    <van-cell-group title="充电桩信息" inset>
      <van-cell title="充电桩名称" :value="chargeinfo.termname" />
      <van-cell title="位置" :value="chargeinfo.place"/>
      <van-cell title="计费方式" :value="chargeinfo.fareinfo"/>
      <van-cell title="客服电话" :value="chargeinfo.telephone"/>
    </van-cell-group>

    <van-cell-group title="插座信息" inset>
      <van-button
        plain
        hairline
        :icon="require('/assets/images/charge_online.png')"
      >
        空闲
      </van-button>
      <van-button
        plain
        hairline
        :icon="require('/assets/images/charge_isuse.png')"
      >
        使用中
      </van-button>
      <van-button
        plain
        hairline
        :icon="require('/assets/images/charge_takeup.png')"
      >
        占用中
      </van-button>
      <van-button
        plain
        hairline
        :icon="require('/assets/images/charge_offline.png')"
      >
        故障
      </van-button>
      <van-grid  clickable column-num="4">
        <van-grid-item  
          v-for="(item, index) in chargelist"
          :key="index"
          @click="ShowRemoteOpen(item)"
        >
          <van-image
            class="imageCharge"
            v-if="item.status==0"
            :src="require('/assets/images/charge_online.png')"
          />
          <van-image
            class="imageCharge"
            v-else-if="item.status==-1"
            :src="require('/assets/images/charge_offline.png')"
          />
          <van-image
            class="imageCharge"
            v-else-if="item.status==1 || item.status==2"
            :src="require('/assets/images/charge_isuse.png')"
          />
          <van-image
            class="imageCharge"
            v-else
            :src="require('/assets/images/charge_status_'+item.status+'.png')"
          />
          <span v-if="IsMe(item)"><van-tag round type="warning">{{item.portname}}</van-tag></span>
          <span v-else>{{item.portname}}</span>
        </van-grid-item>
      </van-grid>
    </van-cell-group>
    <p align="center" style="margin-bottom:50px;">
      <a href="https://beian.miit.gov.cn" id="beian" target="_blank"> {{this.$store.state.beian}}</a>
    </p>
    <br>
    <van-tabbar v-model="active">
      <van-tabbar-item icon="home-o">主页面</van-tabbar-item>
    </van-tabbar>
    <br>
  </template>
  
  <script>
    import { requestGetSysInfo, requestGetUserBaseInfo, requestChargeOpenPort, requestChargePortList, requestChargeClosePort } from '../../api/api'
    import { mapState, mapGetters, mapActions } from 'vuex'
    import { IsBlank, GetBrowserType } from '../../utils/tools/index'
 
  import {
    Grid,
    GridItem,
    Image,
    Tabbar,
    TabbarItem,
    Swipe,
    SwipeItem,
    Tag,
    Cell,
    CellGroup,
    Row,
    Col,
    CouponCell,
    CouponList,
    Popup,
    Icon,
    Dialog,
    Toast,
    NoticeBar,
    ActionBar,
    ActionBarButton,
    ActionBarIcon,
    Button,
    Sticky,
    NavBar,
    Overlay   
  } from "vant";
  
  export default {
    components: {
      [Grid.name]: Grid,
      [GridItem.name]: GridItem,
      [Image.name]: Image,
      [Tabbar.name]: Tabbar,
      [TabbarItem.name]: TabbarItem,
      [Swipe.name]: Swipe,
      [SwipeItem.name]: SwipeItem,
      [Cell.name]: Cell,
      [Tag.name]: Tag,
      [Overlay.name]: Overlay,
      [Sticky.name]: Sticky,
      [NavBar.name]: NavBar,
      [Col.name]: Col,
      [Row.name]: Row,
      [CouponCell.name]: CouponCell,
      [CouponList.name]: CouponList,
      [Popup.name]: Popup,
      [Icon.name]: Icon,
      [Dialog.Component.name]: Dialog.Component,
      [Toast.name]: Toast,
      [NoticeBar.name]: NoticeBar,
      [ActionBar.name]: ActionBar,
      [ActionBarButton.name]: ActionBarButton,
      [ActionBarIcon.name]: ActionBarIcon,
      [Button.name]: Button,
      [CellGroup.name]: CellGroup,
    },
    i18n: {
      "zh-CN": {
        text: "文字",
        route: "页面导航",
        gutter: "格子间距",
        square: "正方形格子",
        columnNum: "自定义列数",
        customContent: "自定义内容",
        urlRoute: "URL 跳转",
        vueRoute: "路由跳转",
        showBadge: "徽标提示",
        horizontal: "内容横排",
      },
      "en-US": {
        text: "Text",
        route: "Route",
        gutter: "Gutter",
        square: "Square",
        columnNum: "Column Num",
        customContent: "Custom Content",
        urlRoute: "URL",
        vueRoute: "Vue Router",
        showBadge: "Show Badge",
        horizontal: "Horizontal",
      },
    },
    watch: {
      active(val) {
        if (val === 1) {
          setTimeout(() => {
             // this.$router.push( '/useroption' + '?t111=' + new Date().getTime() );
          }, 500);
        }
      },
    },
    computed: {
      ...mapState({
        token: state => state.token,
        isbind: state => state.isbind,
        userinfo: state => state.userinfo,
        accesstoken: state => state.accesstoken,
        openid: state => state.openid,
        typekey: state => state.typekey
      }),
      ...mapGetters([
        'openidex',
        'hasopenid',
        'isReAuthLogin',
        'isGrid'
      ])
    },
    data() {
      return {
        isExit: false,
        poscode: '',
        errorcode: true,
        errmsg: '加载中...',
        headpic: '',
        showQrCode: false,
        loadcontent: '加载中...',
        isLoading: false,
        dialogIcon: '',
        dialogTitle: '进入模式',
        chartindex: 0,
        dialogInScene: false,
        showScene: false,
        active: 0,
        charttitle: "用水信息",
        chosenCoupon: -1,
        exchangedCoupons: [],
        chargeinfo: {},
        paytype: 0,
        chargelist: [],
        qrcode: '',
        qrcodevaliddt: 0,
        qrcodeoversec: 0,
        menulist1: [],
        broadcastmsg: '本系统支持内部人员直接使用',
        ws: null,
        paymessage: '等待支付中...',
        qrcodeTimer: null,
        wsexit: false,
        timeDelay: 60,
        nTimeDelayInternal: null,
        nGetPortInternal: null
      };
    },
    async mounted() {
      // this.paytype = GetBrowserType()
      console.log(GetBrowserType())
      this.isLoading=true
      // 如果有errcode代表是有错误发生了，直接显示错误信息\
      var $errcode = this.$route.query.errcode
      var $errmsg = this.$route.query.errmsg
      var $poscode = this.$route.query.poscode
      var $doorid = this.$route.query.portid
      if (IsBlank($poscode) === true) $poscode = this.$route.query.p
      if (IsBlank($doorid) === true) $doorid = this.$route.query.d
      if (IsBlank($poscode) === true) { // 为空
        Dialog.alert({
          title: '错误提醒',
          message: '没有获取到充电桩信息!!!',
        })
        setTimeout(() => {
          this.$router.push('#/energyindex?t1=' + new Date().getTime());
        }, 300);
        return
      }
      console.log(this.getLocalLoginInfo())
      if (IsBlank(this.$store.state.accesstoken)===true) {
        console.log('还没有任何信息，需要去绑定！')
        window.alert('ddd')
        Dialog.alert({
          title: '错误提醒',
          message: '首次使用，需要先绑定信息！' ,
        })
        setTimeout(() => {
          this.$router.push('#/energyindex?t1=' + new Date().getTime());
        }, 1000);
        return;
      }
      this.poscode = $poscode
      await this.GetChargePortList($poscode)
      console.log('___________________________________________')
        console.log('$errcode', $errcode)
        console.log('$errmsg', $errmsg)
        console.log('___________________________________________')
        console.log(IsBlank($errcode))
      if (IsBlank($errcode) === true) { // 为空
        this.errcode = false
        this.errmsg = '加载完成'
        this.errorcode = false
        // 如果accesstoken有信息，那就直接设置进去
        var $accesstoken = this.$store.state.accesstoken
        var $token = this.$store.state.localtoken
        console.log('___________________________________________')
        console.log('$token信息', $token)
        console.log('$accesstoken信息', $accesstoken)
        console.log('___________________________________________')
        if (IsBlank($accesstoken) === false) {
          this.isbind = true
          this.GetBaseUserInfo()
        } 
        // this.GetSysInfo()
      } else {
        console.log('有错误信息出来了，不用跳转了')
        this.errcode = $errcode
        this.errmsg = $errmsg
      }
      setInterval(() => {
        this.nGetPortInternal=this.GetChargePortList(this.poscode)
      }, 5000);

      if (IsBlank($doorid) === false) { // 不为空说明有了端口，可以开了
        setTimeout(async () => {
          const a = this.chargelist.find(item=>item.port==$doorid)
          if(a==undefined || a==null) {
            await this.GetChargePortList(this.poscode)
            const b = this.chargelist.find(item=>item.port==$doorid)
            if(b==undefined || b==null) {
              Dialog.alert({
                title: '错误提醒',
                message: '你扫描的充电端口不在线或不存在!!!' + $doorid,
              })
              this.isLoading=false
              return;
            } else this.ShowRemoteOpen(b)
          } else this.ShowRemoteOpen(a)
        }, 800);
        return;
      }

      this.isLoading=false
      console.log(this.userinfo)
      console.log(this.isbind)
      console.log(this.state)
      console.log('启动结束！')
  
    },
    beforeUnmount() {
      this.isExit=true
      if (this.nTimeDelayInternal!=null) clearInterval(this.nTimeDelayInternal)
      if (this.nGetPortInternal!=null) clearInterval(this.nGetPortInternal)
    },
    methods: {
      ...mapActions([
        'getLocalLoginInfo',
        'getIsNeedAuthLogin',
        'clearAccessToken',
        'getBaseUserInfo'
      ]),
      IsMe(chargeInfo) {
        if (chargeInfo.customerid<=0) {// 说明是非内部人员
          if(chargeInfo.wxid==this.$store.state.userinfo.wxid) return true;
        } else {
          if(chargeInfo.customerid==this.$store.state.userinfo.customerid) return true;
        }
        return false;
      },
      async GetChargePortList(p) {
        if (this.isExit) return
        const res = await requestChargePortList({accesstoken: this.$store.state.accesstoken, poscode: p})
        if (res.return_code==0) { // 如果有数据
          this.chargelist=res.data
          if (this.chargelist.length>0) this.chargeinfo=this.chargelist[0]
        } else {
          Dialog.alert({
            title: '错误提醒2',
            message: '该充电桩没有设置充电端口信息!!!',
          })
          setTimeout(() => {
            this.$router.push('#/chargeindex?t1=' + new Date().getTime());
          }, 300);
          return
        }
      },
      async GetBaseUserInfo(){
        const res = await requestGetUserBaseInfo({accesstoken: this.$store.state.accesstoken})
          if (res.return_code === '0')
          {
            this.$store.commit('updateUserInfo', res.data[0])
            this.menulist1 = []
            res.functionlist.forEach(f => {
              if (f.isshow === '1') {
                if (IsBlank(f.iconcolor)) f.iconcolor = '#FF5733'
                if(f.functionname === 'pay_lakala') {// 拉卡拉充值
                  if (this.paytype ===0 || this.paytype === 1) {
                    f.functionmemo = '微信充值'
                    f.icon = 'wechat'
                    f.iconcolor= '#00ac84'
                  } else if (this.paytype === 2) {
                    f.functionmemo = '支付宝充值'
                    f.icon = 'alipay'
                    f.iconcolor = '#108ee9'
                  } else { 
                    console.log('不支持的充值方式')
                    return
                  }
                }
                this.menulist1.push(f)
                return
              }
              });
            this.headpic = res.picserver + res.data[0].outid + '&t1=' + new Date().getTime();
            this.$store.state.userinfo.facepic = res.picserver + res.data[0].outid
          } else {
            Toast({
                message: res.return_message ,
                icon: 'fail',
              });
            // this.$router.push( '/bind' + '?t1=' + new Date().getTime());
          }
      },
      async GetSysInfo() {
        const param = {accesstoken: this.accesstoken}
        const res  = await requestGetSysInfo(param)
         if (res.return_code === '0') {
          console.log(res)
          this.images = res.bannerinfo
          this.$store.state.beian = res.beian
          this.$store.state.isenablewxpay = res.isenablewxpay
          this.$store.state.isenablealipay = res.isenablealipay
          document.title = res.systemname[0].dpname + ' 服务平台' 
          if (res.broadcastmsg.length>0) this.broadcastmsg = res.broadcastmsg[0].broadcastmsg
          // console.log(res)
        } else {
          Toast({
            message: res.return_message ,
            icon: 'fail',
          });
        }
      },
      async ShowRemoteOpen(r) {
        console.log(r)
        if (r.status==0) {
          // 确认开启
          Dialog.confirm({
            title: '远程确认',
            message: '您确认要远程打开' + r.termname + '-' + r.portname + ' 电源吗？',
          })
          .then(async () => {
              this.loadcontent = '远程开启电源中，请稍候...'
              this.isLoading = true
              const res = await requestChargeOpenPort({accesstoken: this.$store.state.accesstoken, id: r.poscode, port: r.port})
              if (res.return_code == '0') {
                  Toast({
                      message: res.return_message,
                      icon: 'success',
                  });
                  const toast = Toast.loading({
                    duration: 0,
                    forbidClick: true,
                    message: '开启中 60秒',
                  });
                  this.timeDelay=60
                  console.log(this.timeDelay)
                  this.nTimeDelayInternal=setInterval(async () => {
                     this.timeDelay=this.timeDelay-1
                     
                     console.log(this.timeDelay)
                     // if (this.timeDelay%3!=0) return
                     if (this.timeDelay<=0) {
                        this.timeDelay=0
                        clearInterval(this.nTimeDelayInternal)
                        setTimeout(() => {
                          Toast.clear();
                        }, 500);
                        this.isLoading = false
                        await Dialog.alert({
                          title: '远程操控失败',
                          message: '远程开启' + r.termname + '-' + r.portname + ' 失败！！！',
                        })
                        return;
                     }
                     toast.message = `开启中，请稍候${this.timeDelay} 秒`;
                     this.GetChargePortList(this.poscode)
                     const a = this.chargelist.find(item=>item.port===r.port)
                     if(a==undefined || a==null) return
                     // console.log(a.status, a.curstatusname)
                     if(a.status!=0 || a.status!=98) { // 98是占用中
                      clearInterval(this.nTimeDelayInternal)
                      setTimeout(() => {
                        Toast.clear();
                      }, 500);
                      this.isLoading=false
                      Dialog.alert({
                        title: '远程操控结果',
                        message: '远程开启' + r.termname + '-' + r.portname + ':' + a.curstatusname + '！！！',
                      })
                     }
                  }, 1000);
      
              } else {
                  Toast({
                      message: res.return_message,
                      icon: 'fail',
                  });
                  this.isLoading = false
              }
            });
          } else {
            // 确认关闭
          Dialog.confirm({
            title: '远程确认',
            message: '您确认要远程关闭' + r.termname + '-' + r.portname + ' 电源吗？',
          })
          .then(async () => {
              this.loadcontent = '远程关闭电源中，请稍候...'
              this.isLoading = true
              const res = await requestChargeClosePort({accesstoken: this.$store.state.accesstoken, id: r.poscode, port: r.port})
              if (res.return_code === '0') {
                  Toast({
                      message: res.return_message,
                      icon: 'success',
                  });
                  this.timeDelay=60
                  const toast = Toast.loading({
                    duration: 0,
                    forbidClick: true,
                    message: '关闭中 60 秒',
                  });
                  this.nTimeDelayInternal=setInterval(() => {
                     this.timeDelay=this.timeDelay-1
                     if (this.timeDelay<=0) {
                        this.timeDelay=0
                        clearInterval(this.nTimeDelayInternal)
                        Toast.clear();
                        this.isLoading = false
                        Dialog.alert({
                          title: '远程操控失败',
                          message: '远程关闭' + r.termname + '-' + r.portname + ' 失败！！！',
                        })
                        return;
                     }
                     // if (this.timeDelay%3!=0) return
                     toast.message = `关闭中，请稍候 ${this.timeDelay} 秒`;
                     this.GetChargePortList(this.poscode)
                     const a = this.chargelist.find(item=>item.port===r.port)
                     if(a==undefined || a==null) return
                     if(a.status==0 || a.status==-1) {
                      clearInterval(this.nTimeDelayInternal)
                      this.isLoading=false
                      Dialog.alert({
                        title: '远程操控结果',
                        message: '远程关闭' + r.termname + '-' + r.portname + ':' + a.curstatusname + '！！！',
                      })
                      setTimeout(() => {
                        Toast.clear();
                      }, 500);
                     }
                  }, 1000);
      
              } else {
                  Toast({
                      message: res.return_message,
                      icon: 'fail',
                  });
                  this.isLoading = false
              }
            });
          }
      },
      ClickMenu (param) {
        console.log(param);
        // Toast(param)
        setTimeout(() => {
          this.$router.push( param +  '?t1=' + new Date().getTime());        
        }, 300);
      },
      beforeClose(action, done) {
        if (action === 'confirm') {
          setTimeout(done, 1000);
        } else {
          done();
        }
      },
      InScene() {
        console.log('ok')
        Toast({
          message: this.dialogTitle + '成功',
          icon: this.dialogIcon,
        });
      },
      onChangeScene(index) {
        this.showScene = false;
        this.chosenCoupon = index;
      },
      randomId(max = 999999) {
        return Math.floor(Math.random() * max) + 1;
      },
      onChange(index) {
        this.current = index;
      }
    },
  };
  </script>
  
  <style lang="less">
  .van-grid {
    display: flex;
    flex-wrap: wrap;
  }
  .menugrid {
    // display: flex;
    flex-wrap: wrap;
    background-color: transparent;
    margin-bottom: 5px;
    // margin-left: 3px;
  }
  .van-grid-item__content {
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      height: 100%;
      padding: var(--van-grid-item-content-padding);
      background: transparent;
  }
  .qrcodetext {
    margin-left: 5px;
    margin-top: 35px;
    color: #3c3c3f;
    font-size: 15px;
    font-family:"微软雅黑",Georgia,Serif;
  }
  .imageCharge {
    height: 55px;
  }
  .imgDialog {
    box-sizing: border-box;
    width: 100%;
    padding: 25px 20px 0;
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .block {
    width: 120px;
    height: 120px;
    background-color: #fff;
  }
  </style>
  